import React from "react";
import { ProfileContainer } from "./style";
import Profile from "components/profile";
const ProfilePage = () => {
  return (
    <ProfileContainer>
      <div className="letter">
        در این بخش می توانید اطلاعات هویتی خود را تکمیل و در صورت لزوم ویرایش
        نمایید.
        <br />
        توجه داشته باشید اطلاعات درج شده توسط شما در این بخش، مبنای قرارداد خرید
        خواهد بود، لذا خواهشمند است بمنظور جلوگیری از بروز هرگونه مشکل احتمالی
        در آینده، پس از تکمیل دقیق فرم، تمامی اطلاعات وارده را مجددا بررسی نموده
        و از صحت آن اطمینان حاصل فرمایید.
        <br />
        دقت فرمایید، جهت خرید خودرو بصورت "شخصی" میبایست اطلاعات در تَب حقیقی
        درج و تکمیل شود و در صورت خرید خودرو برای اشخاص حقوقی (شرکت ها، سازمان
        ها و موسسات) اطلاعات لازم را در تب مربوط به "اشخاص حقوقی" تکمیل فرمایید.
        <br />
        لازم به ذکر است در صورت عدم تکمیل تمامی اطلاعات ذکر شده در پروفایل، پیش
        از پرداخت اینترنتی وجه، نماد "اطلاعات ضروری" مجددا به نمایش در خواهد
        آمد.
        <br />
        جهت تسریع فرایند خرید در زمان مقرر، پیشنهاد میشود کلیه اطلاعات شخصی خود
        را از قبل تکمیل نمایید تا به هنگام خرید، در کمترین زمان ممکن به درگاه
        پرداخت متصل گردید.
        <br />
        مستحضر باشید، مبنای خرید نهایی از نظر شرکت، رسید قابل چاپ پرداخت
        اینترنتی است که پس از واریز وجه و بازگشت به وبسایت فروش، قابل نمایش
        خواهد بود.
        <br />
        از آنجا که بدلیل تقاضای بالای خرید و ترافیک سایت، بروز اختلال و کندی
        سرعت قابل پیشبینی و اجتناب ناپذیر است پیشاپیش از شکیبایی شما عزیزان
        سپاسگزاریم.
        <br />
        لازم به یادآوری است؛ آپشن‌ها و تریم داخلی خودرو در زمان تحویل ممکن است با اطلاعات مندرج در کاتالوگ و سایت مغایرت داشته باشد.
        <br />
        شرکت آرین پارس موتور ضمن تشکر از شما، تجربه خرید بسیار خوبی را برایتان
        آرزومند است.
      </div>
      <Profile />
    </ProfileContainer>
  );
};
export default ProfilePage;
